import { ComponentBmiForm } from "@components";
import { PATH_HOME } from "@configs";
import { useEffect } from "react";
import { useHistory } from "react-router";

export const PageBmiForm = () => {
    const history = useHistory();
    const prefix = window.location.hostname.split(".")[0];

    useEffect(() => {
        if (prefix !== "nbdreward") {
            history.push(PATH_HOME);
        }
    }, [prefix, history]);

    if (prefix !== "nbdreward") {
        return null;
    }

    return <ComponentBmiForm />;
};
